/**
 * @generated SignedSource<<f3332d921876815ffd0bd5248ba308a9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProjectInvoicingTable_company$data = {
  readonly currency: string | null;
  readonly newXeroEnabled: boolean | null;
  readonly quickbooksEnabled: boolean | null;
  readonly economicEnabled: boolean | null;
  readonly sageIntacctConnectionEnabled: boolean | null;
  readonly integrations: {
    readonly userCanUnlinkInvoice: boolean | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"ExportInvoiceButton_company">;
  readonly " $fragmentType": "ProjectInvoicingTable_company";
};
export type ProjectInvoicingTable_company$key = {
  readonly " $data"?: ProjectInvoicingTable_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectInvoicingTable_company">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "qboInvoicingImprovements"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "xeroInvoicingImprovements"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectInvoicingTable_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currency",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "newXeroEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "quickbooksEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "economicEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sageIntacctConnectionEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CompanyIntegrationsType",
      "kind": "LinkedField",
      "name": "integrations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "userCanUnlinkInvoice",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "qboInvoicingImprovements",
          "variableName": "qboInvoicingImprovements"
        },
        {
          "kind": "Variable",
          "name": "xeroInvoicingImprovements",
          "variableName": "xeroInvoicingImprovements"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ExportInvoiceButton_company"
    }
  ],
  "type": "Company",
  "abstractKey": null
};

(node as any).hash = "e2b42518f20020d62570e93a398f060d";

export default node;
